<div class="bg-surface max-w-screen flex h-screen max-h-screen w-screen flex-col items-stretch overflow-hidden">
  <dtis-header
    [title]="title()"
    [header_links]="header_links()"
    [headerDropdown]="headerDropdown()"
    [headerDropdowns]="headerDropdowns()"
    [headerReadonlyLabel]="headerReadonlyLabel()"
    class="flex-none"
  ></dtis-header>
  <main class="flex flex-grow overflow-hidden">
    @if (!railConfig().isHidden) {
    <dtis-rail-navbar [routes]="railConfig().routes" />
    }
    <div class="border-b-lowEmphasis bg-surface flex h-full w-full flex-col overflow-hidden border-b" [class.overflow-y-scroll]="!useSidebarLayout()">
      @if (useSidebarLayout()) {
      <!-- Sidebar + Detail Layout -->
      <div class="flex h-full w-full">
        <!-- Sidebar Slot -->
        <div class="flex-none">
          <ng-content select="[sidebar]"></ng-content>
        </div>
        <!-- Detail View Slot -->
        <div class="flex-1 overflow-y-auto">
          <router-outlet></router-outlet>
        </div>
      </div>
      } @else {
      <!-- Traditional Layout -->
      <div class="flex h-full w-full flex-col">
        <router-outlet></router-outlet>
      </div>
      }
    </div>
  </main>
  <dtis-footer
    class="flex-shrink-0"
    [displayFooterLogo]="true"
    [appVersion]="appVersion()"
    [metadata]="footerMetaConfig()"
    (toggleDebug)="toggleDebug.emit($event)"
  ></dtis-footer>
  <ng-template #loading>
    <div class="progress-spinner-wrapper">
      <mat-progress-spinner color="primary" mode="indeterminate" diameter="40" value="50" class="progress-spinner"> </mat-progress-spinner>
    </div>
  </ng-template>
</div>
